import TableList from "@components/templates/tablelist";
import { HttpMarkChangeManageList, HttpMarkChangeExamine, HttpMarkChangeListCount, HttpMarkChangeComplete } from "@/service/misc";
import { mapState, mapGetters } from "vuex";
import comIndex from '../markchangecustom/update'
import mixin from '../mixin';

export default {
    mixins: [ TableList, mixin],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    'quanbu': 0,
                },
            },
            exportdata:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            spanTabs: { show: true },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpMarkChangeManageList,
        spanAjaxRequest: () => {
            return HttpMarkChangeListCount({
                isManage: true
            })
        },handleParams (params) {
            if (params.search.quanbu === 0) {
                params.search.EQ_status = null
            }
            else if (params.search.daishenhe === 0) {
                params.search.EQ_status = 5
            }
            else if (params.search.shenhejuhui === 0) {
                params.search.EQ_status = 6
            }
            else if (params.search.daichuli === 0) {
                params.search.EQ_status = 10
            }
            else if (params.search.chulizhong === 0) {
                params.search.EQ_status = 15
            }
            else if (params.search.yiwancheng === 0) {
                params.search.EQ_status = 70
            }
            delete params.search.quanbu
            delete params.search.daishenhe
            delete params.search.shenhejuhui
            delete params.search.daichuli
            delete params.search.chulizhong
            delete params.search.yiwancheng
            this.exportdata = params
            return params
        },
        interceptRequest(params) {
            return this.handleParams(params)
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        isManage: true,
                        alertbox: true,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "markChangeDetail",
                        params: { type: "query"},
                        query: { id: params, isManage: true, },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "audit":
                    this.operate = {
                        show: true,
                        alert: 'error',
                        title: "审核",
                        width: 460,
                        showDesc: false,
                        params: { id: params },
                        formdata: [
                            {
                                label: '审核意见',
                                tag: "vRadio",
                                key: "approveFlag",
                                span: 24,
                                options: [
                                    {
                                        trueValue: 10,
                                        label: "审核通过"
                                    },
                                    {
                                        trueValue: 6,
                                        label: "审核拒回"
                                    },
                                ],
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false,
                            }
                        ],
                        ajaxRequest: HttpMarkChangeExamine,
                        interceptRequest(params){
                            if(!params.approveFlag) {
                                this.$VMessage.error('请填写必填项！')
                                return false
                            }
                            return params
                        }
                    };
                    break;
                case "complete":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('', { defaultValue: '完成' }),
                        width: 460,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false,
                            }
                        ],
                        ajaxRequest: HttpMarkChangeComplete,
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/changeLabelPlan/exportByManage",
                    this.exportdata, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    }).catch(err => {
                        this.$VMessage.error(err.message);
                    })
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: "审核",
                    show: status == 5 ,
                    params: id,
                    operate: 'audit'
                },
                {
                    label: this.$t('global.common.finish', { defaultValue: "完成" }),
                    show: status == 10,
                    params: id,
                    operate: 'complete'
                },
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getCusproductList', 'getUserManageWarehouseList','getSelfmanageorgList']),
        ...mapGetters("common", ["getStateList"]),
        TabsData() {
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: '全部' }),
                    key: 'quanbu',
                    val: 0,
                },
                {
                    name: this.$t('', { defaultValue: "待审核" }),
                    key: 'daishenhe',
                    val: 0,
                    spanKey: 'unApprovedQty',
                },
                {
                    name: this.$t('', { defaultValue: "审核拒回" }),
                    key: 'shenhejuhui',
                    val: 0,
                    spanKey: 'refusedQty',
                },
                {
                    name: this.$t('', { defaultValue: "待处理" }),
                    key: 'daichuli',
                    val: 0,
                    spanKey: 'unProcessQty',
                },
                {
                    name: this.$t('', { defaultValue: "处理中" }),
                    key: 'chulizhong',
                    val: 0,
                    spanKey: 'processingQty',
                },
                {
                    name: this.$t('', { defaultValue: "已完成" }),
                    key: 'yiwancheng',
                    val: 0,
                    spanKey: 'completedQty',
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'export',
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: "单据号",
                    tag: 'Input',
                    key: 'EQ_changeLabelPlanNo',
                    show: true,
                    style: 'width: 150px;'
                },
                {
                    label: "项目",
                    tag: 'Select',
                    key: 'EQ_lineId',
                    options:this.getCusproductList,
                    props:{
                        filterable:true
                    },
                    show:true,
                    style: 'width: 150px;'
                },
                {
                    label: "单据状态",
                    tag: 'Select',
                    key: 'IN_status',
                    options: this.getBillStatus1.slice(1),
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: 'width: 150px;',
                    show:true,
                },
                {
                    label: "仓库",
                    tag: 'Select',
                    key: 'EQ_orgWarehouseCode',
                    options: this.getUserManageWarehouseList.map(item=>{
                        return {
                            value:item.attach.code,
                            label:item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    tag: 'Select',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                // {
                //     label: "库存类型",
                //     tag: "Select",
                //     key: "EQ_inventoryType",
                //     options: [
                //         { value: 0, label: "可售库存" },
                //         { value: 1, label: "不可售库存" },
                //     ],
                //     props: {
                //         filterable: true,
                //     },
                //     style: widthStyle
                // },
                {
                    label: "换标前sku",
                    tag: 'Input',
                    key: 'EQ_changeLabelPlanItemEntities.sku',
                    style: widthStyle
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id',
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                },
                {
                    title: this.$t('global.common.organization', { defaultValue: '组织' }),
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.organizationId) || '--'
                },
                {
                    title: "单据号",
                    sortable: true,
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.changeLabelPlanNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.alloment.order_status', { defaultValue: "单据状态" }),
                    width: 90,
                    render: (h, { row }) => {
                        const status = row.status;
                        const { theme = 'default', label } = this.getBillStatus1.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{status ? label : this.$t('fbb.inbound.draft', { defaultValue: '草稿' })}</vButton>
                    }
                },
                {
                    title: "仓库",
                    key:'orgWarehouseCode',
                    render: (h, { row }) => this.findRenderLabel(this.getUserManageWarehouseList, row.orgWarehouseCode) || '--'
                },
                {
                    title: "项目/库存类型",
                    render: (h, { row }) => {
                        return <div>
                            <div>{this.findRenderLabel(this.getCusproductList, row.lineId) || '--'}</div>
                            <div>{row.inventoryType == 0 ? '可售库存':'不可售库存' || '--'}</div>
                        </div>
                    },
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    width: 180,
                },
            ];
        },

    },
}
